import { render, staticRenderFns } from "./waterFallBaseWork.vue?vue&type=template&id=35b58501&"
import script from "./waterFallBaseWork.vue?vue&type=script&lang=js&"
export * from "./waterFallBaseWork.vue?vue&type=script&lang=js&"
import style0 from "./waterFallBaseWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports